<template>
  <div class="k-banner">
    <picture class="content">
      <source
        :srcset="banner.image"
        media="(min-width: 769px)"
      />
      <img
        class="image"
        :src="banner.image_secondary"
        :alt="banner.name"
        ref="image"
      />
    </picture>
    <div class="overlay"></div>
  </div>
</template>

<script>
export default {
	name: "KBanner",
	props: {
    banner: {
      type: Object,
      required: true
    }
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";;

.k-banner {
  width: 630px;
  height: 340px;
  position: relative;

  @include media-query(mobile) {
    width: 382px;
    height: 200px;
  }

  & .overlay {
    border-radius: 10px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: $neutral-1;
    opacity: 0;
    transition: all ease 0.2s;
  }

  &:hover {
    & .overlay {
      opacity: 0.06;
    }
  }

  & > .content {
    & > .image {
      border-radius: 10px;
      box-sizing: border-box;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/KaledoComponents/KBanner.vue